import React, { Component } from "react";
import {
  Grid,
  Header,
  Button,
  Form,
  Input,
  Transition
} from "semantic-ui-react";
import { connect } from "react-redux";
import { setForm } from "../../../store/actions/form";
import { isEmail, googleTracking } from "../../../util";
import classNames from "classnames";
import {
  AVAILABLE_NOT_PREWIRED,
  AVAILABLE_PREWIRED
} from "../../../data/status";
import { phoneMask } from '../../../util';
import { displayError, resetError } from "../../../store/actions/error";
import ErrorMessage from '../../error-message/ErrorMessage';
import { Loader } from '../../Loader/Loader';

class Step3 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      animation: props.animation,
      errors: {},
      isLoading: false
    };
    this.transitionBack = this.transitionBack.bind(this);
    this.transitionNext = this.transitionNext.bind(this);
    this.onChange = this.onChange.bind(this);
    this.save = this.save.bind(this);
    this.phone = null;
  }

  componentDidMount() {
    const { status } = this.props.connection;
    const { timeslots } = this.props;
    if (status === AVAILABLE_PREWIRED) {
      googleTracking({ 'event': 'virtualPageview', 'pageview': '/prewired/step5/sign-up' });
    }
    else if (status === AVAILABLE_NOT_PREWIRED) {
      googleTracking(
        {
          'event': 'virtualPageview',
          'pageview': '/not-prewired/step5/sign-up',
          'not-prewired_step4_schedule_installation_status': timeslots.length > 0 ? 'viewed' : 'skipped'
        });

    }
    this.setState({
      visible: true
    });

    setTimeout(() => {
      phoneMask(this.phone.inputRef);
    })
    this.props.resetError();
  }

  transitionBack() {
    const { changeStep, connection, promotion, timeslots } = this.props;

    this.setState({
      animation: "fade left",
      visible: false
    });

    if (connection.status === AVAILABLE_NOT_PREWIRED) {
      if (promotion.length > 0 && timeslots.length > 0) {
        setTimeout(() => {
          changeStep(7, "fade right");
        }, 400);
        return;
      }
    }
    if (connection.status === AVAILABLE_PREWIRED) {
      this.goToStep4();
      return;
    }
    this.goToStep2();
  }

  goToStep2() {
    this.props.setForm({ timeslot: null, timeslotObj: {} });
    setTimeout(() => {
      this.props.changeStep(2, "fade right");
    }, 400);
  }

  goToStep4() {
    this.props.setForm({ timeslot: null, timeslotObj: {} });
    setTimeout(() => {
      this.props.changeStep(4, "fade right");
    }, 400);
  }

  checkErrors() {
    const { form } = this.props;
    const errors = {};
    if (!form.first_name) {
      errors["first_name"] = "First name is required.";
    }
    if (!form.last_name) {
      errors["last_name"] = "Last name is required.";
    }
    if (!form.email) {
      errors["email"] = "Email is required.";
    }
    if (!form.confirm_email) {
      errors["confirm_email"] = "Confirm email is required.";
    }

    if (!isEmail(form.email)) {
      errors["email"] = "Invalid Email.";
    }
    if ((form.email && form.email.toLowerCase()) !== (form.confirm_email && form.confirm_email.toLowerCase())) {
      errors["confirm_email"] = "Email addresses don’t match.";
    }
    if (!form.phone) {
      errors["phone"] = "Phone no. is required";
    }

    if (form.phone && form.phone.length < 10) {
      errors["phone"] = "Phone no. is invalid";
    }
    return errors;
  }

  save() {
    const errors = this.checkErrors();
    if (Object.keys(errors).length) {
      this.setState({
        errors
      });
      return;
    }
    this.transitionNext();
  }

  transitionNext() {
    const { changeStep, connection } = this.props;

    this.setState({
      animation: "fade right",
      visible: !this.state.visible
    });

    if (connection.status === AVAILABLE_NOT_PREWIRED) {
      setTimeout(() => {
        changeStep(5, "fade left");
      }, 400);
    } else if (connection.status === AVAILABLE_PREWIRED) {
      setTimeout(() => {
        changeStep(5, "fade left");
      }, 400);
    }
  }

  onChange(e, target) {
    if (target.name === 'phone') {
      phoneMask(this.phone.inputRef);
    }
    this.props.setForm({ [target.name]: target.value });
  }

  render() {
    const { visible, animation, errors, isLoading } = this.state;
    const { form } = this.props;
    return (
      <div>
        <div className="back--icon" onClick={this.transitionBack} />
        <Transition visible={visible} duration={500} animation={animation}>
          <div>
            <Header className="title__main" as="h1" textAlign="center">
              Contact Info
              {/* <Header.Subheader className="text-black mt-7">
                Create your account with Facebook,
              </Header.Subheader>
              <Header.Subheader className="text-black">
                Google,or fill out the form below.
              </Header.Subheader> */}
            </Header>

            <Grid className="form__signup width__xs">
              <Grid.Row className="py-0">
                <Grid.Column className="px-0">
                  {/* <div className="social-login">
                    <Button
                      className="text-uc btn--full"
                      size="medium"
                      color="facebook"
                    >
                      <Image src={facebookLogo} verticalAlign="bottom" />
                      <span>Continue with Facebook</span>
                    </Button>
                    <Button
                      className="bg--grey text-uc btn--full my-5"
                      size="medium"
                    >
                      <Image src={googleLogo} verticalAlign="bottom" />
                      <span className="text-black">
                        Use your Google account
                      </span>
                    </Button>
                    <Divider className="mb-6" horizontal>
                      Or
                    </Divider>
                  </div> */}

                  <Form>
                    <Form.Group widths="equal">
                      <Form.Field
                        className={classNames({
                          "is-error": errors.first_name
                        },
                          "mt-0"
                        )}
                      >
                        <Input
                          placeholder="First name"
                          name="first_name"
                          onChange={this.onChange}
                          {...errors.first_name && {
                            color: "red",
                            icon: "exclamation triangle"
                          }}
                          labelPosition="right"
                          label={<div className="label__text">First name</div>}
                          value={form.first_name}
                        />
                        {errors.first_name && (
                          <div className="error-text">{errors.first_name}</div>
                        )}
                      </Form.Field>
                      <Form.Field
                        className={classNames({ "is-error": errors.last_name }, "mt-0")}
                      >
                        <Input
                          placeholder="Last name"
                          name="last_name"
                          onChange={this.onChange}
                          {...errors.last_name && {
                            color: "red",
                            icon: "exclamation triangle"
                          }}
                          value={form.last_name}
                          labelPosition="right"
                          label={<div className="label__text">Last name</div>}
                        />
                        {errors.last_name && (
                          <div className="error-text">{errors.last_name}</div>
                        )}
                      </Form.Field>
                    </Form.Group>
                    <Form.Field
                      className={classNames({ "is-error": errors.email })}
                    >
                      <Input
                        placeholder="Email"
                        type="email"
                        name="email"
                        onChange={this.onChange}
                        {...errors.email && {
                          color: "red",
                          icon: "exclamation triangle"
                        }}
                        value={form.email}
                        labelPosition="right"
                        label={<div className="label__text">Email</div>}
                      />
                      {errors.email && (
                        <div className="error-text">{errors.email}</div>
                      )}
                    </Form.Field>
                    <Form.Field
                      className={classNames({
                        "is-error": errors.confirm_email
                      })}
                    >
                      <Input
                        placeholder="Confirm Email"
                        name="confirm_email"
                        type="email"
                        onChange={this.onChange}
                        {...errors.confirm_email && {
                          color: "red",
                          icon: "exclamation triangle"
                        }}
                        value={form.confirm_email}
                        labelPosition="right"
                        label={<div className="label__text">Confirm Email</div>}
                      />
                      {errors.confirm_email && (
                        <div className="error-text">{errors.confirm_email}</div>
                      )}
                    </Form.Field>
                    <Form.Field
                      className={classNames({ "is-error": errors.phone })}
                    >
                      <Input
                        placeholder="Phone"
                        name="phone"
                        onChange={this.onChange}
                        {...errors.phone && {
                          color: "red",
                          icon: "exclamation triangle"
                        }}
                        value={form.phone}
                        labelPosition="right"
                        label={<div className="label__text">Phone</div>}
                        ref={(ref) => this.phone = ref}
                      />
                      {errors.phone && (
                        <div className="error-text">{errors.phone}</div>
                      )}
                    </Form.Field>
                    {isLoading ? <Loader /> : <Button
                      size="medium"
                      className="btn--full"
                      onClick={this.save}
                    >Continue</Button>
                    }
                    <ErrorMessage />
                  </Form>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>
        </Transition>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    form: state.form,
    connection: state.connection,
    promotion: state.promotion,
    timeslots: state.timeslots
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setForm: data => dispatch(setForm(data)),
    resetError: () => dispatch(resetError()),
    displayError: () => dispatch(displayError())
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Step3);



// WEBPACK FOOTER //
// ./src/components/check-availability/service-available/Step3.js